import {
  Form, FormSubmitType, Spacing, SpacingName,
} from '@doveit/lego';
import React from 'react';
import PrivacyPolicyFooter from '../privacy-policy-footer/PrivacyPolicyFooter';
import validationSchema from './ContactFormV3.schema';

export interface ContactFormModelV3 {
  email: string,
  name: string,
  phoneNumber?: string,
  marketing?: boolean,
  thirdParties?: boolean,
}

export interface ContactFormV3Props {
  initialValues?: Partial<ContactFormModelV3>,
  loading?: boolean,
  dataRef?: string,
  onSubmit: FormSubmitType<ContactFormModelV3>,
}

const ContactFormV3: React.FC<ContactFormV3Props> = ({
  initialValues,
  loading,
  dataRef = 'contact-form',
  onSubmit,
}) => {
  const initialValuesMerged = React.useMemo(() => ({
    name: '',
    email: '',
    phoneNumber: '',
    fiscalCode: '',
    marketing: false,
    thirdParties: false,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      dataRef={dataRef}
      initialValues={initialValuesMerged}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      loading={loading}
      preventEnterKeypress
    >
      <Form.Item>
        <Form.Input
          type="email"
          name="email"
          label="Email"
          placeholder="Es. mario.rossi@gmail.com"
          aria-label="Campo per inserire il tuo indirizzo e-mail"
          required
        />
      </Form.Item>

      <Form.Item>
        <Form.Input
          name="name"
          placeholder="Es. Mario Rossi"
          label="Nome e cognome"
          aria-label="Campo per inserire il tuo nome"
          required
        />
      </Form.Item>

      <Form.Item>
        <Form.Input
          type="tel"
          name="phoneNumber"
          label="Numero di telefono"
          placeholder="Es. 3381234321"
          aria-label="Campo per inserire il tuo telefono"
        />
      </Form.Item>

      <Form.Item>
        <Form.Checkbox
          name="marketing"
          text="Accetto di ricevere comunicazioni e offerte da parte di Dove.it"
          aria-label="Campo per approvare il consenso al marketing"
        />
      </Form.Item>

      <Form.Item>
        <Form.Checkbox
          name="thirdParties"
          text="Accetto di ricevere comunicazioni e offerte da parte delle società partner di Dove.it"
          aria-label="Campo per approvare il consenso al trasferimento"
        />
      </Form.Item>

      <Form.Item>
        <Form.Submit
          label="Salva"
          aria-label="Salva"
          expanded
        />

        <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
          <PrivacyPolicyFooter />
        </Spacing>
      </Form.Item>
    </Form>
  );
};

export default ContactFormV3;
